type SectionProps = {
  id: string;
  title: string;
  children: React.ReactNode;
  wide?: boolean;
};

export default function Section({ id, title, children, wide = false }: SectionProps) {
  return (
    <section
      id={id}
      className={[
        "scroll-mt-16 mx-auto px-8 py-16 md:px-12",
        wide ? "max-w-7xl" : "max-w-5xl",
      ].join(" ")}
    >
      <h2 className="mb-8 text-center font-serif text-2xl font-bold tracking-wide text-black md:text-3xl">
        {title}
      </h2>
      {children}
    </section>
  );
}